<h2 mat-dialog-title>Add Virtual Product: {{ data.product.name }}</h2>

<div mat-dialog-content>
    @if (loading) {
    <div class="flex flex-col items-center justify-center p-5">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Loading linked products...</p>
    </div>
    }

    @if (error) {
    <div class="text-red-500 p-2.5 mb-4 rounded bg-red-50">
        {{ error }}
    </div>
    }

    @if (!loading && linkedProducts.length === 0) {
    <div class="p-5 text-center text-gray-600">
        <p>This virtual product has no linked products. Please add linked products first.</p>
    </div>
    }

    @if (!loading && linkedProducts.length > 0) {
    <form [formGroup]="form">
        <div class="flex gap-4 mb-4">
            <mat-form-field class="flex-1">
                <mat-label>Charge</mat-label>
                <input matInput type="number" formControlName="charge" min="0">
                <span matPrefix appAddCurrencyPrefix>£</span>
            </mat-form-field>

            <mat-form-field class="flex-1">
                <mat-label>On Hire Date</mat-label>
                <input matInput [matDatepicker]="onHirePicker" formControlName="on_hire">
                <mat-datepicker-toggle matSuffix [for]="onHirePicker"></mat-datepicker-toggle>
                <mat-datepicker #onHirePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="flex-1">
                <mat-label>Estimated Off Hire Date</mat-label>
                <input matInput [matDatepicker]="estOffHirePicker" formControlName="estimated_off_hire">
                <mat-datepicker-toggle matSuffix [for]="estOffHirePicker"></mat-datepicker-toggle>
                <mat-datepicker #estOffHirePicker></mat-datepicker>
            </mat-form-field>
        </div>

        <h3>Select Items for Linked Products</h3>

        <div class="max-h-96 overflow-y-auto mt-4 gap-y-4">
            @for (linkedProductWithIndex of linkedProductsWithIndices; track linkedProductWithIndex.linkedProduct.id) {
            <mat-card class="">
                <mat-card-header>
                    <mat-card-title>{{ linkedProductWithIndex.linkedProduct.linkable.name }}</mat-card-title>
                    <mat-card-subtitle>Select item</mat-card-subtitle>
                </mat-card-header>

                <mat-card-content class="px-4 pb-4">
                    <mat-form-field class="w-full">
                        <mat-label>Select Item</mat-label>
                        <mat-select [formControl]="$any(selectedItemsControls[linkedProductWithIndex.index])">
                            <mat-option
                                *ngFor="let item of availableItemsForProducts.get(linkedProductWithIndex.linkedProduct.linkable.id)"
                                [value]="item.itemId" [disabled]="!item.available || item.hasCurrentWorkshopJobs">
                                {{ item.itemCode }} {{ !item.available ? ' - On hire' : item.hasCurrentWorkshopJobs ? '
                                - In
                                workshop' : '' }}
                            </mat-option>
                        </mat-select>
                        @if (selectedItemsControls[linkedProductWithIndex.index].errors?.['duplicate']) {
                        <mat-error>
                            Item already selected, please select another item
                        </mat-error>
                        }
                        @if (selectedItemsControls[linkedProductWithIndex.index].errors?.['required']) {
                        <mat-error>
                            Please select an item
                        </mat-error>
                        }
                    </mat-form-field>
                </mat-card-content>
            </mat-card>
            }
        </div>
    </form>
    }
</div>

<div mat-dialog-actions align="end">
    <button mat-button (click)="cancel()" [disabled]="loading">Cancel</button>
    @if (!loading && linkedProducts.length > 0) {
    <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="form.invalid || loading">
        Add to Hire
    </button>
    }
</div>